import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { openSnackbar } from 'app/store/actions/page.action';
import { IAccount } from 'app/store/models/account.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { ISelectItem } from 'app/store/models/select.model';
import { IReducers } from 'app/store/reducers';
import { UserService } from 'app/store/services/user.service';
import * as moment from 'moment';

export enum EDeletePeriod {
  ONE_YEAR = 1,
  TWO_YEARS = 2,
}

@Component({
  selector: 'app-manage-deleted-account',
  templateUrl: './manage-deleted-account.component.html',
  styleUrls: ['./manage-deleted-account.component.scss']
})
export class ManageDeletedAccountComponent implements OnInit {

  inputForm: FormGroup;

  account: IAccount;

  deletedPeriods = EDeletePeriod;

  showNotificationPreferences = false;

  triggerChangeNotificationPreferences = false;

  headerText: string;

  componentReady: boolean;


  changeNotificationButtonProperties: Button = {
    text: 'Update',
    color: ButtonColor.ORANGE,
    size: ButtonSize.NORMAL,
    onClick: () => this.updateNotificationPreferences(),
  }

  constructor(
    private readonly userService: UserService,
    private readonly store: Store<IReducers>,
  ) { }


  get periods(): ISelectItem[] {
    return [
      { value: EDeletePeriod.ONE_YEAR, label: '1 Year' },
      { value: EDeletePeriod.TWO_YEARS, label: '2 Years' },
    ]
  }

  ngOnInit(): void {
    if(this.inputForm) {
      this.inputForm.addControl('deleted_forward', new FormControl(this.account.forward_active || 0, [Validators.required]));
      if(this.account.forward_to) {
        const forwardDate = moment(this.account.forward_to);
        const now = moment();
        const diffInYears = Math.round(forwardDate.diff(now, 'years', true));
        let perioiodValue = EDeletePeriod.ONE_YEAR;
        if(diffInYears >= 2) {
          perioiodValue = EDeletePeriod.TWO_YEARS;
        }
        this.inputForm.addControl('period', new FormControl(perioiodValue, [Validators.required]));
      } else {
        this.inputForm.addControl('period', new FormControl(EDeletePeriod.ONE_YEAR, [Validators.required]));
      }

      if(this.showNotificationPreferences) {
        this.inputForm.addControl('change_notification_preferences', new FormControl(false));
        this.inputForm.addControl('email', new FormControl(this.account.notification_email, [Validators.email]));
      }
    }

    this.componentReady = true;
  }

  updateNotificationPreferences(): void {
    if(this.inputForm.get('change_notification_preferences').value) {
      this.userService.setNotificationsEmail(this.account.account_id, this.inputForm.get('email').value, true).subscribe(() => {
        this.store.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: 'Notification preferences updated successfully',
              type: 'success'
            }
          }
        }));
      }, err => this.store.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: err.error,
              type: 'error'
            }
          }
      })));
    }
  }

}
